module.exports = __webpack_public_path__ + "assets/media/clock-about.63eae2b4.svg";